import { render } from "./company.vue?vue&type=template&id=190ff3f8&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"

import "./company.vue?vue&type=style&index=0&id=190ff3f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-190ff3f8"

export default script